import React from 'react';

const InspectableMap = ({ link }) => {
  return (
    <section id="inspectable-map">
      {link ? (
        <iframe
          src={link}
          title="Carte Inspectable"
          width="100%"
          height="500px"
          style={{ border: 'none' }}
        />
      ) : (
        <p>No inspectable map available</p>
      )}
    </section>
  );
};

export default InspectableMap;